<template>
    <div class="selector-wrap">
        <Selector 
        :options="optionList" 
        @dataChange="change" 
        :disabled="disabled" 
        ></Selector>
    </div>
    <!-- :style="style" -->
  </template>
  
  <script>
  import Selector from './Selector.vue'
  
  export default {
    name: 'selector',
    components: { Selector },
    props: {
      placeholder: String,
      parentNodes: {
        type: Array,
        default(){
          return []
        }
      },
      disabled: { type: Boolean, default: false}
    },
    data() {
      // console.log( this.style ) ; 
      return {
        optionList : [],
      }
    },
    watch: {
        parentNodes : function(value){
            this.makeData();
            // console.log( "value", value )
        }
    },
    mounted() {
        // console.log( "this.parentNodes>>>", this.parentNodes );
      if( this.optionList.length > 0 ){
        this.optionList.find(o=>o.select == true).select = false;
      }
      
      this.makeData();
    },
    methods : {
        makeData(){
            this.optionList = [];
            this.optionList.push({value: "", label:"지정 유닛 선택", select: true})
            for( let node of this.parentNodes ){
                this.optionList.push({value : node.key, label : node.text})
            }
            
        },
        change(value) {
            this.$emit('change', value);
        }
    }
  }
  </script>
  
  <style lang="scss" scoped>
    .selector-wrap{
        border:1px solid #999;
        padding:5px 10px;
        z-index:1;
    }
  </style>
  
  
  